import type { NotificationListResponseModel, NotificationListResponseRaw } from '@/domain/models/notification.js';
import { NotificationListResponseModel as NotificationListResponseModelClass } from '@/domain/models/notification.js';
import type { HttpClient } from '@/domain/protocols/http-client.js';
import type { NotificationRepository } from '@/domain/repositories/notification-repository.js';

export class NotificationRepositoryImpl implements NotificationRepository {
    constructor(private readonly httpClient: HttpClient) {}

    public async findAll(params?: { page?: number; limit?: number; filter?: 'all' | 'unread' | 'read' }): Promise<NotificationListResponseModel> {
        const qs = new URLSearchParams();
        if (params?.page) {
            qs.set('page', String(params.page));
        }
        if (params?.limit) {
            qs.set('limit', String(params.limit));
        }
        if (params?.filter && params.filter !== 'all') {
            qs.set('isRead', params.filter === 'read' ? 'true' : 'false');
        }
        const response = await this.httpClient.request<NotificationListResponseRaw>({ url: `/api/notifications?${qs}`, method: 'GET' });
        return NotificationListResponseModelClass.withFromResponse(response.body);
    }

    public async markRead(id: string): Promise<void> {
        await this.httpClient.request({ url: `/api/notifications/${encodeURIComponent(id)}/read`, method: 'PATCH' });
    }

    public async markAllRead(): Promise<void> {
        await this.httpClient.request({ url: '/api/notifications/read-all', method: 'PATCH' });
    }

    public async getUnreadCount(): Promise<{ count: number }> {
        const response = await this.httpClient.request<{ count: number }>({ url: '/api/notifications/unread-count', method: 'GET' });
        return response.body;
    }
}
